
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/dining",
      function () {
        return require("private-next-pages/[hid]/dining/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hid]/dining"])
      });
    }
  